import { jsx as _jsx } from "react/jsx-runtime";
import '@shopify/polaris/build/esm/styles.css';
import { AppProvider as PolarisProvider } from '@shopify/polaris';
import { useI18n } from '@shopify/react-i18n';
import en from './translations/en.json';
import LoginPage from './pages/Login.tsx';
const AppLogin = ({ is_signup, }) => {
    const [i18n, ShareTranslations] = useI18n({
        id: 'Translations',
        translations: {
            en: en,
        },
    });
    return (_jsx(PolarisProvider, { i18n: i18n.translations, children: _jsx(ShareTranslations, { children: _jsx(LoginPage, { is_signup: is_signup }) }) }));
};
export default AppLogin;
